const DB_NAME = "navatel";
const STORE_NAMES = ["files", "images"];
const MAX_ITEMS = 1000;

const openDatabase = async (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 4);

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const db = (event.target as IDBOpenDBRequest).result;
      STORE_NAMES.forEach((storeName) => {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, {
            keyPath: "id",
            autoIncrement: true,
          });
        }
      });
    };

    request.onsuccess = (event: Event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      resolve(db);
    };

    request.onerror = (event: Event) => {
      reject((event.target as IDBOpenDBRequest).error);
    };
  });
};

export const addItemToIndexDB = async (storeName: string, item: any): Promise<void> => {
  const db = await openDatabase();
  const transaction = db.transaction(storeName, "readwrite");
  const store = transaction.objectStore(storeName);
  const request = store.put(item);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve();
    request.onerror = (event: Event) => reject((event.target as IDBRequest).error);
  });
};

export const getItemFromIndexDB = async (storeName: string, itemId: string): Promise<any> => {
  const db = await openDatabase();
  const transaction = db.transaction(storeName, "readonly");
  const store = transaction.objectStore(storeName);
  const request = store.get(itemId);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = (event: Event) => reject((event.target as IDBRequest).error);
  });
};

export const updateItemInIndexDB = async (storeName: string, item: any): Promise<void> => {
  const db = await openDatabase();
  const transaction = db.transaction(storeName, "readwrite");
  const store = transaction.objectStore(storeName);
  const request = store.put(item);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve();
    request.onerror = (event: Event) => reject((event.target as IDBRequest).error);
  });
};

export const deleteItem = async (storeName: string, itemId: number): Promise<void> => {
  const db = await openDatabase();
  const transaction = db.transaction(storeName, "readwrite");
  const store = transaction.objectStore(storeName);
  const request = store.delete(itemId);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve();
    request.onerror = (event: Event) => reject((event.target as IDBRequest).error);
  });
};

const deleteOldestItems = async (db: IDBDatabase, count: number): Promise<void> => {
  const transaction = db.transaction(STORE_NAMES[0], "readwrite");
  const store = transaction.objectStore(STORE_NAMES[0]);
  const request = store.openCursor();

  return new Promise((resolve, reject) => {
    request.onsuccess = (event: Event) => {
      const cursor = (event.target as IDBRequest).result as IDBCursorWithValue | null;
      if (cursor) {
        store.delete(cursor.primaryKey);
        resolve();
      }
    };

    request.onerror = (event: Event) => reject((event.target as IDBRequest).error);
  });
};

const getCount = async (db: IDBDatabase): Promise<number> => {
  const transaction = db.transaction(STORE_NAMES[0], "readonly");
  const store = transaction.objectStore(STORE_NAMES[0]);
  const request = store.count();

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = (event: Event) => reject((event.target as IDBRequest).error);
  });
};

export const itemExists = async (storeName: string, itemId: number): Promise<boolean> => {
  const db = await openDatabase();
  const transaction = db.transaction(storeName, "readonly");
  const store = transaction.objectStore(storeName);
  const request = store.get(itemId);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(!!request.result);
    request.onerror = (event: Event) => reject((event.target as IDBRequest).error);
  });
};

export const deleteDB = async (): Promise<void> => {
  const request = indexedDB.deleteDatabase(DB_NAME);

  request.onsuccess = () => {
    console.log("Database deleted successfully");
  };

  request.onerror = (event: Event) => {
    console.error("Error deleting database:", (event.target as IDBRequest).error);
  };
};
